import React from 'react'
import Terms from '../../Componet/Terms'
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import Ops1 from '../../Componet/Operations/Ops1'


function TermsConditions() {
    return (
        <>
            <HerosectionHeader folder1={"pages"} folder2={"Utilities"} name={"IT Solutions"} />
            <div class="page-content">
                <Ops1></Ops1>
                <NewsletterL1 />
            </div>
        </>
    )
}

export default TermsConditions
